<template>
  <div class="backgroundImage mb-0" id="container">
    <div class="mx-auto px-4 pt-10 h-full">
      <div v-if="isReady" class="bg-white p-4 border-yellow-500 border-8 rounded-lg shadow-lg max-w-3xl mx-auto mb-24">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <!-- First column  -->
          <div class="col-span-1">
            <!-- col-1 row-1  -->
            <div class="col-span-1">
              <label class="block text-gray-700 text-sm font-bold mb-2" for="pickup-location">
                Pick-up Location
              </label>
              <select
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="pickup-location" v-model="pickupLocation">
                <option v-for="(val, index) in locations" :value="val.id">
                  {{ val.label }}
                </option>
              </select>
            </div>
            <!-- col-1 row-2  -->
            <div class="col-span-1 mt-5">
              <label class="block text-gray-700 text-sm font-bold mb-2 mt-2" for="pickup-location">
                Pick-up Places
              </label>
              <select
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="pickup-location" v-model="formData.pickupPlace">
                <option v-for="(val, index) in pickupPlaces" :value="val.label">
                  {{ val.label }}
                </option>
              </select>
            </div>
            <!-- col-1 row-3  -->
            <div v-if="diffLocationToggle">
              <label class="block text-gray-700 text-sm font-bold mb-2 mt-5" for="pickup-location">
                Drop-off location
              </label>
              <select v-model="dropOffLocation"
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="dropoff-location">
                <option v-for="(val, index) in locations" :value="val.id">
                  {{ val.label }}
                </option>
              </select>

              <label class="block text-gray-700 text-sm font-bold mb-2 mt-2" for="pickup-location">
                Drop-off Places
              </label>
              <select
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="pickup-location" v-model="formData.dropOffPlace">
                <option v-for="(val, index) in dropOffPlaces" :value="val.label">
                  {{ val.label }}
                </option>
              </select>
            </div>
          </div>
          <!-- col-2   -->
          <div class="col-span-1 md:col-span-2 grid grid-cols-2 gap-4">
            <!-- col-2 row-1  -->
            <div class="col-span-1">
              <label class="block text-gray-700 text-sm font-bold mb-2" for="pickup-date">
                Pick-up date
              </label>
              <input v-model="formData.pickupDate"
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="pickup-date" placeholder="Fri 22 Mar" type="date" />
            </div>
            <!-- col-3 row-1  -->
            <div class="col-span-1">
              <label class="block text-gray-700 text-sm font-bold mb-2" for="pickup-time">
                Time
              </label>
              <input v-model="formData.pickupTime"
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="pickup-time" placeholder="10:00" type="time" />
            </div>
            <!-- col-2 row-2  -->
            <div class="col-span-1">
              <label class="block text-gray-700 text-sm font-bold mb-2" for="dropoff-date">
                Drop-off date
              </label>
              <input v-model="formData.dropoffDate"
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="dropoff-date" placeholder="Sat 27 Apr" type="date" />
            </div>
            <!-- col-3 row-2  -->
            <div class="col-span-1">
              <label class="block text-gray-700 text-sm font-bold mb-2" for="dropoff-time">
                Time
              </label>
              <input v-model="formData.dropoffTime"
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="dropoff-time" placeholder="10:00" type="time" />
            </div>
            <!-- Search Button  -->
            <div class="col-span-2 md:col-span-1 flex justify-center">
              <button @click="getRate()"
                class="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-3 rounded w-full md:w-64 md:h-12"
                style="width: 14rem">
                Search
              </button>

            </div>
          </div>
        </div>
        <!-- ============= After Search button section================ -->
        <div class="flex items-center justify-between mt-4">
          <section class="flex items-center">
            <input v-model="diffLocationToggle" class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              id="different-location" type="checkbox" />
            <label class="ml-2 block text-sm text-gray-900" for="different-location">
              Drop car off at different location
            </label>
          </section>

        </div>

      </div>
    </div>

  </div>
</template>

<script>
import { axiosMixin } from "@/mixin/axiosMixin";

export default {
  mixins: [axiosMixin],
  data() {
    return {
      vehicleGroup: this.$store.state.main.vehicleGroup,

      dropoffDate: this.calculateSevenDaysFromNowDropOffDate(),

      pickupDate: this.calculateFiveDaysFromNowPickUpDate(),
      isDriverAge: "",
      isReady: false,
      locations: {},
      pickupPlaces: {},
      dropOffPlaces: {},
      ageRange: false,
      diffLocationToggle: false,
      pickupLocation: "",
      dropOffLocation: "",
      formData: {
        pickupPlace: "",
        dropOffPlace: "",
        pickupDate: "",
        pickupTime: "10:00",
        dropoffDate: "",
        dropoffTime: "10:00",
      },
      // vehicleGroup: {},
    };
  },
  computed: {
    reservationData() {
      return this.$store.state.main.reservationData;
    },
    updateUi() {
      return this.$store.state.main.updateUiForReservation;
    },
  },

  methods: {
    calculateFiveDaysFromNowPickUpDate() {
      const today = new Date();
      const fiveDaysFromNow = new Date(today.setDate(today.getDate() + 5));
      return fiveDaysFromNow.toISOString().split("T")[0]; // formats date as "YYYY-MM-DD"
    },
    calculateSevenDaysFromNowDropOffDate() {
      const today = new Date();
      const fiveDaysFromNow = new Date(today.setDate(today.getDate() + 7));
      return fiveDaysFromNow.toISOString().split("T")[0]; // formats date as "YYYY-MM-DD"
    },
    startLoading() {
      this.$vs.loading({
        container: "#container",
        scale: 0.6,
      });
    },
    stopLoading() {
      this.$vs.loading.close("#container > .con-vs-loading");
    },
    getLocations() {
      this.startLoading();
      this.aronGet("getInformation", "", "", "")
        .then((response) => {
          console.log("response:", response);
          if (response.status) {
            this.locations = response.data.locations;
            this.$store.state.main.nationalities = response.data.nationalities;
          } else {
            this.errorAlert("Error", response.data.error);
          }
          this.isReady = true;
          this.stopLoading();
        })
        .catch((error) => {
          console.log("error:", error);
          this.stopLoading();
          this.isReady = true;
        });
    },


    getRate() {
      this.startLoading();

      //get the bookingDetails.main from vuex store

      if (!this.diffLocationToggle) {
        this.formData.dropOffPlace = this.formData.pickupPlace;
      }
      this.$store.state.main.bookingDetails.formData = this.formData;
      //
      this.aronPost("getRate", this.formData, "", "")
        .then((response) => {
          if (response.status) {
            this.vehicleGroup = response.data.rate;
            this.$store.state.main.vehicleGroup = response.data.rate;
            var extras = response.data.extras;
            for (let i = 0; i < extras.length; i++) {
              extras[i].Quantity = 0;
            }
            this.$store.state.main.extras = extras;

            this.$router.push("/listing").catch(() => { });
          } else {
            this.errorAlert("Error", response.data.error);
          }
          this.isReady = true;
          this.stopLoading();
        })
        .catch((error) => {
          console.log("errorsss:", error);
          this.stopLoading();
          this.isReady = true;
        });
    },

    getPlaceBaseOnLocation(subject) {
      this.startLoading();
      var locationSubject = this.dropOffLocation;
      if (subject == "pickup") {
        locationSubject = this.pickupLocation;
      }
      this.aronPost(
        "getPlaceBaseOnLocation",
        { location: locationSubject },
        "",
        ""
      )
        .then((response) => {
          if (response.status) {
            if (subject == "pickup") {
              this.pickupPlaces = response.data.places;
            } else {
              this.dropOffPlaces = response.data.places;
            }
          } else {
            this.errorAlert("Error", response.data.error);
          }
          this.isReady = true;
          this.stopLoading();
        })
        .catch((error) => {
          console.log("error:", error);
          this.stopLoading();
          this.isReady = true;
        });
    },
  },
  watch: {
    // This will be called whenever 'someData' changes
    pickupLocation: function (newValue, oldValue) {
      this.getPlaceBaseOnLocation("pickup");
    },
    dropOffLocation: function (newValue, oldValue) {
      this.getPlaceBaseOnLocation("dropOff");
    },
    formData: {
      handler: function (newValue, oldValue) {
        this.$store.state.main.formData = newValue;
      },
      deep: true,
    },
    updateUi: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.pickupLocation = this.reservationData.Pickup.Station.Code;
          this.formData.pickupPlace = this.reservationData.Pickup.Place.Name;
          this.formData.pickupDate = this.reservationData.Pickup.Date.split("T")[0];
          this.formData.pickupTime = this.reservationData.Pickup.Date.split("T")[1];

          //dropoff place and time
          this.dropOffLocation = this.reservationData.Dropoff.Station.Code;
          this.formData.dropOffPlace = this.reservationData.Dropoff.Place.Name;
          this.formData.dropoffDate = this.reservationData.Dropoff.Date.split("T")[0];
          this.formData.dropoffTime = this.reservationData.Dropoff.Date.split("T")[1];

          this.$store.state.main.reservationType = "update";
        } else {
          this.$store.state.main.reservationType = "new";
          this.pickupLocation = "";
          this.formData.pickupPlace = "";
          this.formData.pickupDate = "";
          this.formData.pickupTime = "";

          //dropoff place and time
          this.dropOffLocation = "";
          this.formData.dropOffPlace = "";
          this.formData.dropoffDate = "";
          this.formData.dropoffTime = "";

        }

      },
      deep: true
    }
  },
  mounted() {
    this.isReady = false;
    this.getLocations();
    this.formData.pickupDate = this.calculateFiveDaysFromNowPickUpDate();
    this.formData.dropoffDate = this.calculateSevenDaysFromNowDropOffDate();
  },
};
</script>

<style scoped>
*,
::after,
::before {
  box-sizing: border-box;
  border-width: 0;
  border-style: solid;
  border-color: #e5e7eb;
}

::after,
::before {
  --tw-content: "";
}

:host,
html {
  line-height: 1.5;
  -webkit-text-size-adjust: 100%;
  -moz-tab-size: 4;
  tab-size: 4;
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-feature-settings: normal;
  font-variation-settings: normal;
  -webkit-tap-highlight-color: transparent;
}

body {
  margin: 0;
  line-height: inherit;
}

hr {
  height: 0;
  color: inherit;
  border-top-width: 1px;
}

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
  text-decoration: underline dotted;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

a {
  color: inherit;
  text-decoration: inherit;
}

b,
strong {
  font-weight: bolder;
}

code,
kbd,
pre,
samp {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
    "Liberation Mono", "Courier New", monospace;
  font-feature-settings: normal;
  font-variation-settings: normal;
  font-size: 1em;
}

small {
  font-size: 80%;
}

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

table {
  text-indent: 0;
  border-color: inherit;
  border-collapse: collapse;
}

button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  font-feature-settings: inherit;
  font-variation-settings: inherit;
  font-size: 100%;
  font-weight: inherit;
  line-height: inherit;
  color: inherit;
  margin: 0;
  padding: 0;
}

button,
select {
  text-transform: none;
}

[type="button"],
[type="reset"],
[type="submit"],
button {
  -webkit-appearance: button;
  background-color: transparent;
  background-image: none;
}

:-moz-focusring {
  outline: auto;
}

:-moz-ui-invalid {
  box-shadow: none;
}

progress {
  vertical-align: baseline;
}

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}

summary {
  display: list-item;
}

blockquote,
dd,
dl,
figure,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

menu,
ol,
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

dialog {
  padding: 0;
}

textarea {
  resize: vertical;
}

input::placeholder,
textarea::placeholder {
  opacity: 1;
  color: #9ca3af;
}

[role="button"],
button {
  cursor: pointer;
}

:disabled {
  cursor: default;
}

audio,
canvas,
embed,
iframe,
img,
object,
svg,
video {
  display: block;
  vertical-align: middle;
}

img,
video {
  max-width: 100%;
  height: auto;
}

[hidden] {
  display: none;
}

*,
::before,
::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x: ;
  --tw-pan-y: ;
  --tw-pinch-zoom: ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position: ;
  --tw-gradient-via-position: ;
  --tw-gradient-to-position: ;
  --tw-ordinal: ;
  --tw-slashed-zero: ;
  --tw-numeric-figure: ;
  --tw-numeric-spacing: ;
  --tw-numeric-fraction: ;
  --tw-ring-inset: ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur: ;
  --tw-brightness: ;
  --tw-contrast: ;
  --tw-grayscale: ;
  --tw-hue-rotate: ;
  --tw-invert: ;
  --tw-saturate: ;
  --tw-sepia: ;
  --tw-drop-shadow: ;
  --tw-backdrop-blur: ;
  --tw-backdrop-brightness: ;
  --tw-backdrop-contrast: ;
  --tw-backdrop-grayscale: ;
  --tw-backdrop-hue-rotate: ;
  --tw-backdrop-invert: ;
  --tw-backdrop-opacity: ;
  --tw-backdrop-saturate: ;
  --tw-backdrop-sepia: ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x: ;
  --tw-pan-y: ;
  --tw-pinch-zoom: ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position: ;
  --tw-gradient-via-position: ;
  --tw-gradient-to-position: ;
  --tw-ordinal: ;
  --tw-slashed-zero: ;
  --tw-numeric-figure: ;
  --tw-numeric-spacing: ;
  --tw-numeric-fraction: ;
  --tw-ring-inset: ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur: ;
  --tw-brightness: ;
  --tw-contrast: ;
  --tw-grayscale: ;
  --tw-hue-rotate: ;
  --tw-invert: ;
  --tw-saturate: ;
  --tw-sepia: ;
  --tw-drop-shadow: ;
  --tw-backdrop-blur: ;
  --tw-backdrop-brightness: ;
  --tw-backdrop-contrast: ;
  --tw-backdrop-grayscale: ;
  --tw-backdrop-hue-rotate: ;
  --tw-backdrop-invert: ;
  --tw-backdrop-opacity: ;
  --tw-backdrop-saturate: ;
  --tw-backdrop-sepia: ;
}

.container {
  width: 100%;
}

@media (min-width: 640px) {
  .container {
    max-width: 640px;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}

@media (min-width: 1024px) {
  .container {
    max-width: 1024px;
  }
}

@media (min-width: 1280px) {
  .container {
    max-width: 1280px;
  }
}

@media (min-width: 1536px) {
  .container {
    max-width: 1536px;
  }
}

.col-span-1 {
  grid-column: span 1 / span 1;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.ml-2 {
  margin-left: 0.5rem;
}

.ml-4 {
  margin-left: 1rem;
}

.mt-2 {
  margin-top: 0.5rem;
}

.mt-4 {
  margin-top: 1rem;
}

.mt-8 {
  margin-top: 2rem;
}

.block {
  display: block;
}

.flex {
  display: flex;
}

.grid {
  display: grid;
}

.h-4 {
  height: 1rem;
}

.w-4 {
  width: 1rem;
}

.w-full {
  width: 100%;
}

.max-w-3xl {
  max-width: 100rem;
}

.appearance-none {
  -webkit-appearance: none;
  appearance: none;
}

.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.grid-cols-2 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.items-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.gap-4 {
  gap: 1rem;
}

.space-x-4> :not([hidden])~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}

.rounded {
  border-radius: 0.25rem;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.border {
  border-width: 1px;
}

.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}

.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}

.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity));
}

.bg-transparent {
  background-color: transparent;
}

.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.p-4 {
  padding: 1rem;
}

.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.text-center {
  text-align: center;
}

.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}

.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.font-bold {
  font-weight: 700;
}

.font-semibold {
  font-weight: 600;
}

.leading-tight {
  line-height: 1.25;
}

.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity));
}

.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}

.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}

.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color),
    0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1),
    0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color),
    0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\:border-transparent:hover {
  border-color: transparent;
}

.hover\:bg-blue-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 64 175 / var(--tw-bg-opacity));
}

.hover\:bg-green-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity));
}

.focus\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity));
}

@media (min-width: 768px) {
  .md\:col-span-2 {
    grid-column: span 4 / span 1;
  }

  .md\:grid-cols-3 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}

.backgroundImage {
  background: url("./img/background-large.jpg");
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  height: 100dvh;
}
</style>
